import { Show, Text } from "@chakra-ui/react";
import { Card, CardContent, CardHeader } from "@ui/components/card";

export interface NRICensusMapPopupProps {
  id?: string | number;
  tractfips: string;
  county: string;
  state: string;

  stat: {
    name: string;
    value: number;
  };

  setPopover: (state: any) => void;
}

export default function NRICensusPopup(props: NRICensusMapPopupProps) {
  return (
    <Show above="sm">
      <Card
        position="absolute"
        top="2"
        left="2"
        borderRadius="inherit"
        p="4"
        pb="0"
      >
        <CardHeader
          p="0"
          mb="1"
          title={`Selected Census Tract`}
          subtitle={`${props.tractfips}`}
          subtitleProps={{
            fontWeight: "bold",
            textDecoration: "underline"
          }}
        />
        <CardContent as="dl" lineHeight={"shorter"} p="0">
          <Text as="dt" color="blue.500" fontWeight="medium">
            {props.stat.name}
          </Text>
          <Text as="dd" fontWeight="extrabold" fontSize="lg">
            {props.stat.value ? `${props.stat.value}/year` : "N/A"}
          </Text>
        </CardContent>
      </Card>
    </Show>
  );
}
